import L from "leaflet";
import { useEffect } from "react";
import { MapContainer, Marker, TileLayer, useMap } from "react-leaflet";

function OSMapAction({ lat = 0, long = 0 }) {
  // Leaflet Default-Icon Fix für React
  const defaultIcon = L.icon({
    iconUrl: "/marker-icon.png",
    shadowUrl: "/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });
  L.Marker.prototype.options.icon = defaultIcon;

  const map = useMap();

  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        map.invalidateSize();
      }, 200);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [map]);

  map.invalidateSize();
  if (lat && long) {
    map.setView([lat, long], map.getZoom());
    console.log("map center:", map.getCenter());
    return <Marker position={[lat, long]}></Marker>;
  }
  return null;
}

const OSMap = ({ lat = 0, long = 0 }) => {
  return (
    <div style={{ height: "300px", width: "100%" }}>
      <MapContainer
        center={[lat, long]}
        zoom={20}
        scrollWheelZoom={false}
        style={{ height: "300px", width: "100%" }}
      >
        <OSMapAction lat={lat} long={long} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
    </div>
  );
};

export default OSMap;
